<script setup>
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useUISettings } from 'dashboard/composables/useUISettings';

import Policy from 'dashboard/components/policy.vue';

const route = useRoute();
const { uiSettings, updateUISettings } = useUISettings();

const routePermissions = computed(
  () => route.meta.permissions || ['administrator', 'agent']
);
const routeFeatureFlag = computed(() => route.meta.featureFlag || null);
const routeInstallationTypes = computed(
  () => route.meta.installationTypes || null
);

watch(
  () => route.params.assistantId,
  newAssistantId => {
    if (
      newAssistantId &&
      newAssistantId !== String(uiSettings.value.last_active_assistant_id)
    ) {
      updateUISettings({
        last_active_assistant_id: Number(newAssistantId),
      });
    }
  }
);
</script>

<template>
  <Policy
    :permissions="routePermissions"
    :feature-flag="routeFeatureFlag"
    :installation-types="routeInstallationTypes"
    class="flex w-full h-full min-h-0"
  >
    <section class="flex flex-1 h-full px-0 overflow-hidden bg-n-surface-1">
      <router-view />
    </section>
  </Policy>
</template>
